import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { organizationsApi } from '@/lib/api/organizations';
import { toast } from 'sonner';

export function useOrganizations() {
  const queryClient = useQueryClient();

  const query = useQuery({
    queryKey: ['organizations'],
    queryFn: organizationsApi.list,
  });

  const createMutation = useMutation({
    mutationFn: organizationsApi.create,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['organizations'] });
      toast.success("Workspace created");
    },
    onError: (error: Error) => {
      toast.error(error.message || "Failed to create workspace");
    },
  });

  return {
    organizations: query.data,
    isLoading: query.isLoading,
    error: query.error,
    createOrganization: createMutation.mutateAsync,
    isCreating: createMutation.isPending,
  };
}

export function useUpdateOrganization() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: ({ orgId, data }: { orgId: string; data: { name: string; description?: string } }) =>
      organizationsApi.update(orgId, data),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['organizations'] });
      toast.success("Workspace updated");
    },
    onError: (error: Error) => {
      toast.error(error.message || "Failed to update workspace");
    },
  });
}
